import { selectOrderState } from '../reducer/orderSlice';
import { useAppSelector } from '../../../app/hooks';
import useGetOrderInformationsByOrderId from '../utils/orderHooks';
import { useParams } from 'react-router-dom';
import { HeaderSection } from './complementary/HeaderSection';
import { LoaderIcon } from 'react-hot-toast';
import { useMemo, useState } from 'react';
import { ITab } from 'src/components/PageHeader/tabHeader/TabHeader';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import theme from '@theme';
import { DualPanel } from '../../../../src/components/DualPanel';
import Card from '@designSystem/Card';
import { format, parseISO } from 'date-fns';
// import Clock from '../../../images/clock.svg';
import { statusStrategy } from '../utils/constants';
import { ClockFill, Box } from 'react-bootstrap-icons';
const OrderRecapOperaBasic = ({
  historic = [],
  mepDate = '-',
  equipementId = '-',
  idSuivi = '-',
  spvCode = '-'
}: {
  historic: {
    commentaire: string;
    date: string;
    etat: 'INITIALE' | 'EN_COURS' | 'ABANDONNEE' | 'VALIDEE';
  }[];
  mepDate: string;
  equipementId?: string;
  idSuivi: string;
  spvCode: string;
}) => {
  const { t } = useTranslation();
  const { orderId } = useParams();
  const { order: orderStore } = useAppSelector(selectOrderState);
  const { order } = useGetOrderInformationsByOrderId(orderId || orderStore?.id || '');

  const defaultTab = [
    {
      name: t('order.orderRecap.orderReacapComplementary.additional.info.general', 'Général'),
      state: 'general',
      i18nKey: 'order.orderRecap.orderReacapComplementary.additional.info.general'
    },
    {
      name: t('order.orderRecap.orderReacapComplementary.additional.info.history', 'Historique'),
      state: 'history',
      i18nKey: 'order.orderRecap.orderReacapComplementary.additional.info.history'
    }
  ];

  const [tabSelected, setTabSelected] = useState<ITab>(defaultTab[0]);
  const otoRef = useMemo(() => {
    return (
      order?.productOrderItem[0].product.place?.[0]?.finalOtoRef ||
      order?.productOrderItem[0].product.place?.[0]?.otoRef ||
      '-'
    );
  }, [order]);
  if (!order)
    return (
      <div
        style={{
          minHeight: '200px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <LoaderIcon />
      </div>
    );

  return (
    <div style={{ width: '350px' }}>
      <HeaderSection tabs={defaultTab} setTabSelected={setTabSelected} tabSelected={tabSelected} />
      <Container>
        {tabSelected.state === 'general' && (
          <>
            <b>{t('features.orderRecap.complementary.opera.title.equipment', 'Équipement')}</b>
            <DualPanel
              left={
                <div>
                  {t('features.orderRecap.complementary.opera.follow', 'N° suivi de l’équipement')}
                </div>
              }
              right={
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {idSuivi}
                  {idSuivi !== '-' && (
                    <Box
                      style={{ cursor: 'pointer' }}
                      color={theme.palette.blue[500]}
                      size="16px"
                      onClick={() =>
                        window.open(
                          `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${idSuivi}`,
                          '_blank'
                        )
                      }
                    />
                  )}
                </div>
              }
            />
            <DualPanel
              left={
                <>
                  <div>
                    {t(
                      'features.orderRecap.complementary.opera.idEquipement',
                      'Identifiant de l’équipement'
                    )}
                  </div>
                </>
              }
              right={<div>{equipementId}</div>}
            />
            <b>{t('features.orderRecap.complementary.opera.title.pto', 'PTO')}</b>

            <DualPanel
              left={
                <>
                  <div>
                    {t('features.orderRecap.complementary.opera.idPTO', 'Identifiant de la PTO  ')}
                  </div>
                </>
              }
              right={<div>{otoRef}</div>}
            />
            <b>{t('features.orderRecap.complementary.opera.title.plug', 'Raccordement')}</b>

            <DualPanel
              left={
                <>
                  <div>
                    {t(
                      'features.orderRecap.complementary.opera.dateMep',
                      'Date de Mise en service'
                    )}
                  </div>
                </>
              }
              right={<div>{mepDate}</div>}
            />
            <DualPanel
              left={
                <>
                  <div>{t('features.orderRecap.complementary.opera.realm', 'Extension Realm')}</div>
                </>
              }
              right={<div>{spvCode}</div>}
            />
          </>
        )}
        {tabSelected.state === 'history' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'auto' }}>
            {historic.length === 0 && <div>Aucun commentaire mis à jour</div>}
            {historic.map((commentsDetail, i: number) => {
              const statusData = statusStrategy(t)[commentsDetail.etat];
              const { iconStatus, status, color, iconLabel } = statusData || {};
              return (
                <CustomCard key={i}>
                  <div
                    style={{
                      fontSize: theme.fonts.size.base,
                      fontWeight: theme.fonts.weight.medium,
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <div> {format(parseISO(commentsDetail.date), 'dd-MM-yyyy hh:mm:ss')}</div>
                  </div>
                  <div
                    style={{
                      color: theme.palette.grey[500],
                      fontSize: theme.fonts.size.sm,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      marginBottom: '5px',
                      marginTop: '5px',
                      fontWeight: 500
                    }}
                  >
                    <ClockFill fill={theme.palette.grey[400]} width={12} height={12} />
                    Commentaire :
                  </div>
                  <div
                    style={{
                      color: theme.palette.grey[500],
                      fontSize: theme.fonts.size.sm,
                      fontWeight: 500
                    }}
                  >
                    {commentsDetail.commentaire || 'N/A'}
                  </div>
                </CustomCard>
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
};

export default OrderRecapOperaBasic;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const EllipsisContainer = styled.div`
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  color: ${theme.palette.grey[700]}:;
`;

const CustomCard = styled(Card)`
  max-width: 100%;
  background-color: ${theme.palette.grey[100]};
`;
